var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14904",
    "data-name": "Group 14904",
    transform: "translate(-1016 -202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35671",
    "data-name": "Path 35671",
    d: "M1042.25,195.478a2.5,2.5,0,0,1,3.27,3.269l-5.92,14.217a3,3,0,0,1-5.73-.661l-.74-4.434-4.43-.739a3,3,0,0,1-.66-5.728Zm1.43,2.5a.5.5,0,0,0-.66-.654l-14.21,5.924a1,1,0,0,0,.22,1.909l4.43.739a2,2,0,0,1,1.64,1.644l.74,4.434a1,1,0,0,0,1.91.22Z",
    transform: "translate(0 17)",
    fill: "#777e91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4546",
    "data-name": "Rectangle 4546",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(1017 203)",
    fill: "none",
    stroke: "#e6e8ec",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.4bae7d9f71a9ad15b76f968ab79675cb.svg";
export { ForwardRef as ReactComponent };